var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47792 7.59003L1.54135 4.65347L0.5625 5.63232L4.47792 9.54774L12.8681 1.15756L11.8892 0.178711L4.47792 7.59003Z",
    fill: "#0E9E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingCheck);
export default __webpack_public_path__ + "static/media/pricingCheck.34beca4caff6c3eaadb8db37058273d4.svg";
export { ForwardRef as ReactComponent };